import { render } from "./ScenarioText.vue?vue&type=template&id=61a26c86&scoped=true&ts=true"
import script from "./ScenarioText.vue?vue&type=script&lang=ts"
export * from "./ScenarioText.vue?vue&type=script&lang=ts"

import "./ScenarioText.vue?vue&type=style&index=0&id=61a26c86&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a26c86"]])

export default __exports__